import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  let options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.get(`${url}/locations`, options).then((response) => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta,
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(
      `${url}/locations/${id}?include=organization,contacts,manager,users`,
      options
    )
    .then((response) => {
      let location = jsona.deserialize(response.data);
      delete location.links;
      return location;
    });
}

function add(location) {
  const payload = jsona.serialize({
    stuff: location,
    includeNames: null,
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/locations?include=organization`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function update(location) {
  const payload = jsona.serialize({
    stuff: location,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(
      `${url}/locations/${location.id}?include=organization`,
      payload,
      options
    )
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/locations/${id}`, options);
}

function attachUsers(location) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(
      `${url}/locations/attach-users/${location.id}?include=organization`,
      location,
      options
    )
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function detachUsers(location) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(
      `${url}/locations/detach-users/${location.id}?include=organization`,
      location,
      options
    )
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}
export default {
  list,
  get,
  add,
  update,
  destroy,
  attachUsers,
  detachUsers,
};
